export default "/images/73d21650809790490dc98f81ab7a04f7.avif";